import { useState } from "react";
import { Copy } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
    Dialog,
    DialogContent,
    DialogDescription,
    DialogHeader,
    DialogTitle,
} from "@/components/ui/dialog";
import {
    Tooltip,
    TooltipContent,
    TooltipProvider,
    TooltipTrigger,
} from "@/components/ui/tooltip";

interface ConnectDialogProps {
    isOpen: boolean;
    command?: string;
    onOpenChange: (isOpen: boolean) => void;
}

export function ConnectDialog({ isOpen, command, onOpenChange }: ConnectDialogProps) {
    const [copied, setCopied] = useState(false);

    return (
        <Dialog open={isOpen} onOpenChange={onOpenChange}>
            <DialogContent className="sm:max-w-[600px]">
                <DialogHeader>
                    <DialogTitle>Connect to Instance</DialogTitle>
                    <DialogDescription>
                        Run this command in your terminal to connect to the instance.
                    </DialogDescription>
                </DialogHeader>
                <div className="p-2 bg-muted rounded-md overflow-auto flex justify-between items-start gap-2">
                    <pre className="flex-1">
                        <code className="whitespace-pre-wrap break-all text-xs">{command}</code>
                    </pre>
                    <TooltipProvider>
                        <Tooltip delayDuration={0} open={copied}>
                            <TooltipTrigger asChild>
                                <Button
                                    size="sm"
                                    variant="ghost"
                                    className="h-7 shrink-0"
                                    onClick={() => {
                                        if (command) {
                                            navigator.clipboard.writeText(command);
                                        }
                                        setCopied(true);
                                        setTimeout(() => setCopied(false), 1000);
                                    }}
                                >
                                    <Copy className="h-3.5 w-3.5" />
                                </Button>
                            </TooltipTrigger>
                            <TooltipContent>
                                Copied!
                            </TooltipContent>
                        </Tooltip>
                    </TooltipProvider>
                </div>
            </DialogContent>
        </Dialog>
    );
} 